import { connect } from 'react-redux';

import { fetchCurrentData, switchType } from '../../store/actions';
import { selectTypeForPanel, selectTitleForPanel, selectOptions, selectConfigForPanel } from './selectors';
import Panel from './Panel.component';

const mapStateToProps = (state, props) => ({
  type: selectTypeForPanel(state, props),
  title: selectTitleForPanel(state, props),
  options: selectOptions(state),
  config: selectConfigForPanel(state, props),
})

const mapDispatchToProps = (dispatch, props) => ({
  fetchCurrentData: () => dispatch(fetchCurrentData()),
  switchType: type => dispatch(switchType(props.id)(type)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Panel)


// WEBPACK FOOTER //
// ./src/components/Panel/Panel.container.js